/* eslint-disable no-void */
import { InterestAccountTransferResponse, InterestAccountTransferRequest } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import useDataFetchIndicator from '../useDataFetchIndicator';

const hook = vopayApi.withApiHook(({ api }) => {
  return function usePostInterestAccountTransfer() {
    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const source = axios.CancelToken.source();

    const [response, setResponse] = useState<InterestAccountTransferResponse>({
      Success: false,
      ErrorMessage: '',
      TransactionID: '',
    });

    const postInterestAccountTransfer = async (requestParams: InterestAccountTransferRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.postInterestAccountTransfer(requestParams, source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      // pending,
      response,
      postInterestAccountTransfer,
    };
  };
});
export default hook({});
